import useInput from '../../hooks/use-input';
import { Parameter } from '../../types/Parameter';


type PaperParametersProps = {
  parameters: Parameter[];
  addParameterToPaper?: (repoId: string, paperId:string, key: string, value: number, unit: string) => Promise<void>;
  removeParameterFromPaper?: (repoId: string, paperId:string, parameterId: string) => Promise<void>;
  repoId: string;
  paperId: string;
}

const PaperParameters = (props: PaperParametersProps) => {
  const { value: parameterValue, valueChangeHandler: parameterValueChangeHandler, inputBlurHandler: parameterValueBlurHandler, reset: resetParameterValue } = useInput('');
  const { value: parameterName, valueChangeHandler: parameterNameChangeHandler, inputBlurHandler: parameterNameBlurHandler, reset: resetParameterName } = useInput('');
  const { value: parameterUnit, valueChangeHandler: parameterUnitChangeHandler, inputBlurHandler: parameterUnitBlurHandler, reset: resetParameterUnit } = useInput('');
  // const { value, bind: bindParameterValue, reset: resetParameterValue } = useInput('');
  // const { value: type, bind: bindParameterType, reset: resetParameterType } = useInput('');


  const addParameter = (event:any) => {
    event.preventDefault();
    if(!parameterValue) return;
    if(props.addParameterToPaper){
      props.addParameterToPaper(props.repoId ,props.paperId, parameterName, parseFloat(parameterValue), parameterUnit);
      resetParameterValue();
      resetParameterName();
      resetParameterUnit();
    }
  }

  const removeParameterHandler = (parameterId: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if(props.removeParameterFromPaper){
      props.removeParameterFromPaper(props.repoId, props.paperId, parameterId);
    }
  }

  return (
    <div className="row mb-3">
      <div className="col-md-12">
        <span className="title-top">Parameters</span>
        <div className="parameters-list">
          <form onSubmit={addParameter}>
            {props.addParameterToPaper &&
            <div>
              <input className="typeInput py-2 name" id="para-add" placeholder="Type to add new parameter" value={parameterName}
                onChange={parameterNameChangeHandler}
                onBlur={parameterNameBlurHandler} />
              <input className="typeInput py-2 num" id="value-add" placeholder="Type Value" value={parameterValue}
                onChange={parameterValueChangeHandler}
                onBlur={parameterValueBlurHandler} />
              <input className="typeInput py-2 unit" id="unit-add" placeholder="Type Unit" value={parameterUnit}
                onChange={parameterUnitChangeHandler}
                onBlur={parameterUnitBlurHandler} />
              <button className="btn para-addbtn" onClick={addParameter} >Add</button>
             </div>
            }
          </form>
            <ul className="Para-addList tagsinput">
              {props.parameters &&
                props.parameters.map((parameter, index) => <li className="tag" key={index}>{parameter.key} {parameter.value && <span className="num">{parameter.value} {parameter.unit}</span>}
                {props.removeParameterFromPaper &&
                  <button className="tag-remove" onClick={(e) => removeParameterHandler(parameter.id)(e)}></button>
                }
                </li>)
              }
            </ul>
        </div>
      </div>
    </div>
  );
}

export default PaperParameters;
